import { Link } from 'react-router-dom';
import { ArrowRight, Headphones, ShieldCheck, TrendingDown, Flag } from 'lucide-react';
import { useTranslation } from '@/hooks/useTranslation';
import { useReveal } from '@/hooks/useReveal';

const pointIcons = [ShieldCheck, TrendingDown, Flag];

/** Compact, sober homepage teaser for the CX Services section (links to /cx). */
const CxTeaserSection = () => {
  const { t } = useTranslation();
  const teaser = t.cx.teaser;
  useReveal();

  return (
    <section id="cx" style={{ padding: '0 6vw 120px' }}>
      <div className="rev rounded-[var(--r-lg)] grid lg:grid-cols-[1.2fr_1fr] gap-10 items-center p-10 md:p-14" style={{ background: 'var(--ink)', color: 'var(--white)' }}>
        <div>
          <div className="section-tag" style={{ color: 'var(--amber)' }}>{teaser.tag}</div>
          <h2 className="text-3xl md:text-4xl font-bold leading-tight mb-5" style={{ fontFamily: 'var(--f-display)' }}>{teaser.title}</h2>
          <p className="text-base md:text-lg leading-relaxed mb-8 max-w-2xl" style={{ color: 'rgba(255,255,255,0.78)' }}>{teaser.text}</p>
          <Link to="/cx" className="inline-flex items-center gap-2 px-7 py-3.5 rounded-full font-bold text-sm uppercase tracking-wider transition-all hover:scale-105" style={{ background: 'var(--amber)', color: 'var(--ink)', fontFamily: 'var(--f-body)' }}>
            {teaser.cta} <ArrowRight size={16} />
          </Link>
        </div>
        <div className="flex flex-col gap-3">
          <div className="flex items-center gap-3 mb-1">
            <div className="w-10 h-10 rounded-full flex items-center justify-center" style={{ background: 'var(--blue)', color: 'var(--white)' }}><Headphones size={18} /></div>
            <span className="text-xs font-bold uppercase tracking-[0.16em]" style={{ fontFamily: 'var(--f-mono)', color: 'rgba(255,255,255,0.6)' }}>Cyprus · Transylvania · EU</span>
          </div>
          {teaser.points.map((p, i) => {
            const Icon = pointIcons[i] ?? ShieldCheck;
            return (
              <div key={i} className="flex items-center gap-4 p-4 rounded-2xl" style={{ background: 'rgba(255,255,255,0.06)', border: '1px solid rgba(255,255,255,0.1)' }}>
                <Icon size={18} style={{ color: 'var(--amber)', flexShrink: 0 }} />
                <span className="text-sm md:text-base" style={{ color: 'rgba(255,255,255,0.9)' }}>{p}</span>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default CxTeaserSection;
